import { render, staticRenderFns } from "./FormBlock.vue?vue&type=template&id=4a8a4275&scoped=true&"
import script from "./FormBlock.vue?vue&type=script&lang=js&"
export * from "./FormBlock.vue?vue&type=script&lang=js&"
import style0 from "./FormBlock.vue?vue&type=style&index=0&id=4a8a4275&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8a4275",
  null
  
)

export default component.exports